import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { VesselService } from '@service/vessel.service';
import { ButtonDisabledStateComponent } from './button-disabled-state/button-disabled-state.component';
import { ButtonFlashingStateComponent } from './button-flashing-state/button-flashing-state.component';
import {
    ButtonAction,
    DisabledStatus,
    ElementSettings,
    FlashingStatus,
} from 'icreate/common/models/editor-viewer-element';
import { CanvasInputMode } from '@service/canvas/canvas-input-mode.service';
import { ElementAttribute } from '@src/app/models/editor';

@Component({
    selector: 'app-button-element-interactions',
    templateUrl: './button-element-interactions.component.html',
    styleUrls: ['./button-element-interactions.component.css'],
    standalone: false,
})
export class ButtonElementInteractionsComponent implements OnInit, OnChanges {
    @Input() element: SVGElement;
    @Input() elementSettings: ElementSettings;
    @Input() showTitle: boolean = true;

    @ViewChild('disabledStateComponent') disabledStateComponent: ButtonDisabledStateComponent;
    @ViewChild('flashingStateComponent') flashingStateComponent: ButtonFlashingStateComponent;

    shouldShowActions: boolean = false;

    disabledStatus: DisabledStatus;
    flashingStatus: FlashingStatus;
    buttonAction: ButtonAction;

    vesselId: string;

    constructor(private vesselService: VesselService) {}

    ngOnInit(): void {
        this.vesselId = this.vesselService.getActiveVesselId();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.elementType == CanvasInputMode.BUTTON) this.shouldShowActions = true;

        if (this.elementSettings) {
            this.disabledStatus = this.elementSettings.disabledStatus;
            this.flashingStatus = this.elementSettings.flashingStatus;
            this.buttonAction = this.elementSettings.buttonAction;
        }
    }

    handleActionSelected(buttonAction: ButtonAction) {
        this.buttonAction = buttonAction;
    }

    updateSettings() {
        if (this.elementType == CanvasInputMode.BUTTON) this.elementSettings.buttonAction = this.buttonAction ?? null;
        this.elementSettings.disabledStatus = this.disabledStateComponent?.currentDisabledStatus ?? null;
        this.elementSettings.flashingStatus = this.flashingStateComponent?.currentFlashingStatus ?? null;
    }

    get elementType() {
        if (this.element) {
            return this.element.getAttribute(ElementAttribute.type);
        }
        return null;
    }

    get shouldShowFlashingOption() {
        return (
            this.elementType &&
            this.elementType !== CanvasInputMode.INPUT_VALUE &&
            this.elementType !== CanvasInputMode.TOGGLE
        );
    }

    get states(): { disabledStatus: DisabledStatus; flashingStatus: FlashingStatus } {
        const flashingStatus = this.flashingStateComponent?.currentFlashingStatus;
        const disabledStatus = this.disabledStateComponent?.currentDisabledStatus;

        return {
            disabledStatus,
            flashingStatus,
        };
    }

    get hasSettingError(): boolean {
        if (this.elementType == CanvasInputMode.BUTTON && !this.buttonAction) return true;
        if (this.shouldShowFlashingOption && this.flashingStateComponent?.hasMissingParameters) return true;
        if (this.disabledStateComponent?.hasMissingParameters) return true;
        return false;
    }
}
